import styled from 'styled-components';

export const ScMenuSwitchLanguage = styled.div`
  margin-top: 24px;

  & > div > button {
    height: 56px;
    border-radius: 12px;
    padding: 16px 12px;

    .value {
      margin-left: 12px;
    }
    .switchArrow {
      position: absolute;
      right: 12px;

      svg {
        transform: rotate(90deg);
      }
      path {
        stroke: ${({ theme }) => theme.whiteColor};
      }
    }
  }
`;
